import { Card } from '@ibinder/common-frontend';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import ListContainer from './ListContainer';

const DocumentListContent = styled.div`
  padding: 0 1rem 1rem 1rem;
  height: 100%;
  align-self: stretch;
  @media (max-width: ${(p) => p.theme.devices.xs}px) {
    padding: 0 0.5rem 1rem 0.5rem;
  }
`;

const TabTree = ({ nodeData }) => {
  return (
    <>
      {nodeData?.value && (
        <DocumentListContent>
          {nodeData?.value.subTabs.length === 0 ? (
            <ListContainer type={nodeData.value.type} />
          ) : (
            nodeData?.value.subTabs.map((subtab, key) => {
              return (
                <Link key={key} to={`/tab/${subtab.id}`}>
                  <Card
                    showCheckbox={false}
                    label={subtab.name}
                    key={key}
                    showIcon={false}
                  />
                </Link>
              );
            })
          )}
        </DocumentListContent>
      )}
    </>
  );
};

export default TabTree;
